import React, { useEffect, useState } from "react";
import useStyles from "@/styles/deviceControlStyle";
import { Grid } from "@material-ui/core";
import { AccessAlarm, CalendarToday } from "@material-ui/icons";
import DeviceControWithSwitch from "@/components/deviceControl/DeviceControWithSwitch";
import DeviceControlSet from "@/components/deviceControl/DeviceControlSet";
import * as localforage from "localforage";
import HasPermission from "@/components/commons/HasPermission";
import { deviceControlIcon } from "@/helpers/deviceControlIcon";
import VncFailedDialog from "@/components/device/VncFailedDialog";
import ScreenshotDialog from "@/components/deviceControl/ScreenshotDialog";
import RestartSystem from "@/components/deviceControl/RestartSystem";
import KioskMode from "@/components/deviceControl/KioskMode";
import KioskModeAndroid from "@/components/deviceControl/KioskModeAndroid";
import KioskModeWindows from "@/components/deviceControl/KioskModeWindows";
import OraUpdate from "@/components/deviceControl/OraUpdate";
import CmsUpdate from "@/components/deviceControl/CmsUpdate";
import GrayScaleUpdate from "@/components/deviceControl/GrayscaleUpdate";
import DisableAndroidDeviceOwner from "@/components/deviceControl/DisableAndroidDeviceOwner";
import ImageUpdate from "@/components/deviceControl/ImageUpdate";
import ImageGrayScaleUpdate from "@/components/deviceControl/ImageGrayscaleUpdate";
import Rotation from "@/components/deviceControl/Rotation";
import VncSetting from "@/components/deviceControl/VncSetting";
import DeployFile from "@/components/deviceControl/DeployFile";
import IoSetUp from "@/components/deviceControl/IoSetUp";
import CMSPlayer from "@/components/deviceControl/CMSPlayer";
import useStateOnMounted from "@/helpers/useStateOnMounted";
import { toast } from "@/apis/request";
import { useTranslation } from "@/langs/useTranslation";
import { getDeviceTwinsApi } from "@/apis/deviceDetailAPI";
import showLoadingIndicator, {
  hideLoadingIndicator
} from "@/components/Modal/showLoadingIndicator";
import { detectAppRunningApi } from "@/apis/appRunningStatusAPI";
import { getTwinsDesiredOrReportedByLastUpdated } from "@/helpers/utils";
import { getUserInfo } from "@/apis/getUserInfo";
import { APP_ENV } from "@/APP_ENV";

const DeviceControls = ({
  devices: selectDevices,
  crossSelect,
  onSetAlarm,
  onSetSchedule,
  groupId,
  tagId
}) => {
  const { t } = useTranslation("deviceControl");
  const classes = useStyles();
  const {
    lockUsbPortGray,
    lockCombinationKeyGray,
    blockWindowsNotifyGray,
    brightnessGray,
    volumeGray,
    transformGray,
    lockUsbPortBlack,
    lockCombinationKeyBlack,
    blockWindowsNotifyBlack,
    brightnessBlack,
    volumeBlack,
    transformBlack,
    remoteDesktopBlack,
    remoteDesktopGray,
    deployFileGray,
    deployFileBlack,
    updateOraBlack,
    updateOraGray,
    rotationBlack,
    rotationGray,
    kioskModeBlack,
    kioskModeGray,
    restartSystemBlack,
    restartSystemGray,
    ioSetBlack,
    ioSetGray,
    iso,
    AppsIcon,
    admin,
    cmsPlayer,
    cms
  } = deviceControlIcon;

  // const [groupId, setGroupId] = useState("");
  // const [tagId, setTagId] = useState("");
  const [checkAll, setCheckAll] = useState(false);
  // const [selectType, setSelectType] = useState("company");
  const [checkedUsbDrives, setCheckedUsbDrives] = useState(false);
  const [checkedFunctionKeys, setCheckedFunctionKey] = useState(false);
  const [checkedWindowsNotify, setCheckedWindowsNotify] = useState(false);
  const [checkedBrightness, setCheckedBrightness] = useState(false);
  const [checkedVolumes, setCheckedVolumes] = useState(false);
  const [sliderBrightness, setSliderBrightness] = useState(0);
  const [sliderVolumes, setSliderVolumes] = useState(0);
  const [selectCompany, setSelectCompany] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const [dialogContent, setDialogContent] = useState("");
  const [openScreenshot, setOpenScreenshot] = useState(false);
  const [openVNC, setOpenVNC] = useState(false);
  const [showRestartSystem, setShowRestartSystem] = useState(false);
  const [showKioskMode, setShowKioskMode] = useState(false);
  const [showKioskModeAndroid, setShowKioskModeAndroid] = useState(false);
  const [showKioskModeWindows, setShowKioskModeWindows] = useState(false);
  const [kioskMode, setKioskMode] = useState(true);
  const [orientation, setOrientation] = useState("landscape");
  const [cmsEnabledType, setCmsEnabledType] = useState("1");
  const [cmsPlayEnabledType, setCmsPlayEnabledType] = useState("1");
  const [showOraUpdate, setShowOraUpdate] = useState(false);
  const [showCmsUpdate, setShowCmsUpdate] = useState(false);
  const [showImageUpdate, setShowImageUpdate] = useState(false);
  const [showGrayscaleUpdate, setShowGrayscaleUpdate] = useState(false);
  const [showImageGrayscaleUpdate, setShowImageGrayscaleUpdate] =
    useState(false);
  const [showDisableDeviceOwner, setShowDisableDeviceOwner] = useState(false);
  const [showCMSPlayer, setShowCMSPlayer] = useState(false);
  const [showRotation, setShowRotation] = useState(false);
  const [showVncSetting, setShowVncSetting] = useState(false);
  const [showDeloyFile, setShowDeloyFile] = useState(false);
  const [showIoSetUp, setShowIoSetUp] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const [VNCLink, setVNCLink] = useStateOnMounted("");
  // eslint-disable-next-line no-unused-vars
  const [VNCExpiredDate, setVNCExpiredDate] = useStateOnMounted();

  const numType = selectDevices.length <= 1 ? "single" : "multiple";
  const selectDevice = selectDevices[0];

  const selectType = (() => {
    if (crossSelect) {
      if (tagId) return "tag";
      if (groupId && groupId.length) return "group";
    }
    return "device";
  })();

  const attributes = {
    selectDevices,
    selectDevice,
    numType,
    selectType,
    selectCompany,
    groupId,
    tagId,
    checkAll,
    disabled: selectDevices.some(
      device => device.online_offline_status !== "online"
    )
  };

  const deviceControlWithSwitch = [
    {
      // permission: "multiple_remote_desktop",
      type: "remoteDesktop",
      imgSrc: { Black: remoteDesktopBlack, Gray: remoteDesktopGray },
      notAllowGroup: true,
      showDialog: showDialog,
      setVNCLink: setVNCLink,
      setVNCExpiredDate: setVNCExpiredDate,
      setDialogContent: setDialogContent,
      handleVNCFailedDialogOpen: () => setOpenVNC(true)
    },
    {
      permission: "device_control_group_command_usblock",
      type: "lockUsbDrives",
      imgSrc: { Black: lockUsbPortBlack, Gray: lockUsbPortGray },
      notAllowAndroid: true,
      checked: checkedUsbDrives,
      setChecked: setCheckedUsbDrives
    },
    {
      // permission: "multiple_lock_function_keys",
      type: "lockFunctionKey",
      imgSrc: { Black: lockCombinationKeyBlack, Gray: lockCombinationKeyGray },
      notAllowAndroid: true,
      checked: checkedFunctionKeys,
      setChecked: setCheckedFunctionKey
    },
    {
      permission: "device_control_group_command_notify",
      type: "blockWindowsNotify",
      imgSrc: { Black: blockWindowsNotifyBlack, Gray: blockWindowsNotifyGray },
      notAllowAndroid: true,
      checked: checkedWindowsNotify,
      setChecked: setCheckedWindowsNotify
    },
    {
      permission: "device_control_group_command_brightness",
      type: "brightness",
      imgSrc: { Black: brightnessBlack, Gray: brightnessGray },
      slider: sliderBrightness,
      setSlider: setSliderBrightness,
      checked: checkedBrightness,
      setChecked: setCheckedBrightness
    },
    {
      permission: "device_control_group_command_volume",
      type: "volumes",
      imgSrc: { Black: volumeBlack, Gray: volumeGray },
      slider: sliderVolumes,
      setSlider: setSliderVolumes,
      checked: checkedVolumes,
      setChecked: setCheckedVolumes
    },
    {
      permission: "device_control_group_command_alarm_deploy",
      type: "settingAlarm",
      imgSrc: { Black: AccessAlarm, Gray: AccessAlarm }
    },
    {
      permission: "device_control_group_command_schedule_task_deploy",
      type: "settingSchedule",
      imgSrc: { Black: CalendarToday, Gray: CalendarToday }
    }
  ];

  const deviceControlSets = [
    {
      permission: "device_control_group_command_filedeploy",
      type: "deployFile",
      imgSrc: { Black: deployFileBlack, Gray: deployFileGray },
      clickHandler: () => clickHandler("deployFile")
    },
    // {
    //   // permission: "multiple_io_set_up",
    //   type: "ioSetUp",
    //   imgSrc: { Black: ioSetBlack, Gray: ioSetGray },
    //   clickHandler: () => clickHandler("ioSetUp")
    // },
    {
      permission: "device_control_group_command_rotate",
      type: "rotation",
      imgSrc: { Black: rotationBlack, Gray: rotationGray },
      clickHandler: () => clickHandler("rotation")
    },
    {
      permission: "device_control_group_command_oraupdate",
      type: "oraUpdate",
      imgSrc: { Black: updateOraBlack, Gray: updateOraGray },
      clickHandler: () => clickHandler("oraUpdate")
    },
    {
      permission: "mercant_command_cms_player_update",
      type: "cmsUpdate",
      imgSrc: { Black: cms, Gray: cms },
      clickHandler: () => clickHandler("cmsUpdate")
    },
    // {
    //   permission: "device_control_group_command_grayscaleupdate",
    //   type: "grayscaleUpdate",
    //   imgSrc: { Black: updateOraBlack, Gray: updateOraGray },
    //   clickHandler: () => clickHandler("grayscaleUpdate")
    // },
    {
      permission: "device_control_group_command_image_oraupdate",
      type: "imageUpdate",
      imgSrc: { Black: iso, Gray: iso },
      clickHandler: () => clickHandler("imageUpdate")
    },
    // {
    //   permission: "device_control_group_command_image_grayscaleupdate",
    //   type: "imageGrayscaleUpdate",
    //   imgSrc: { Black: iso, Gray: iso },
    //   clickHandler: () => clickHandler("imageGrayscaleUpdate")
    // },
    // {
    //   permission: "device_control_group_command_kiosk",
    //   type: "kioskMode",
    //   imgSrc: { Black: kioskModeBlack, Gray: kioskModeGray },
    //   clickHandler: () => clickHandler("kioskMode")
    // },
    {
      permission: "device_control_group_command_kiosk",
      type: "kioskModeAndroid",
      imgSrc: { Black: kioskModeBlack, Gray: kioskModeGray },
      clickHandler: () => clickHandler("kioskModeAndroid")
    },
    {
      permission: "device_control_group_command_kiosk",
      type: "kioskModeWindows",
      imgSrc: { Black: kioskModeBlack, Gray: kioskModeGray },
      clickHandler: () => clickHandler("kioskModeWindows")
    },
    {
      permission: "device_control_group_command_reboot",
      type: "restartSystem",
      imgSrc: { Black: restartSystemBlack, Gray: restartSystemGray },
      clickHandler: () => clickHandler("restartSystem")
    },
    {
      permission: "device_control_group_command_screenshot",
      type: "screenshot",
      imgSrc: { Black: transformBlack, Gray: transformGray },
      clickHandler: () => clickHandler("screenshot")
    },
    {
      permission: "merchant_command_cms_player",
      type: "cmsPlayer",
      imgSrc: { Black: cmsPlayer, Gray: cmsPlayer },
      clickHandler: () => clickHandler("cmsPlayer"),
      shouldShow: () => APP_ENV.REACT_APP_CMS_ENABLED
    },
    {
      permission: "device_detail_app_running_status",
      type: "appRunningStatus",
      imgSrc: { Black: AppsIcon, Gray: AppsIcon },
      clickHandler: () => clickHandler("appRunningStatus")
    },
    {
      permission: "",
      shouldShow: () => {
        return !getUserInfo()?.company.parent_company_id;
      },
      type: "disableAndroidDeviceOwner",
      notAllowWindows: true,
      imgSrc: { Black: admin, Gray: admin },
      clickHandler: () => clickHandler("disableAndroidDeviceOwner")
    }
  ];

  const clickHandler = async type => {
    // 单选
    // if (numType === "single") {
    //   // 沒选
    //   if (!selectDevice) {
    //     toast.info(t("noty.noSelectDevice"));
    //     return;
    //   }
    // }
    // // 多选
    // else {
    //   // 沒选
    //   if (selectDevices.length === 0) {
    //     toast.info(t("noty.noSelectDevice"));
    //     return;
    //   }
    // 不允许多选
    if (
      selectDevices.length > 1 &&
      (type === "remoteTerminal" || type === "remoteDesktop")
    ) {
      toast.info(t("noty.forSingleDevice"));
      return;
    }
    // }
    switch (type) {
      case "deployFile":
        setShowDeloyFile(true);
        break;
      case "ioSetUp":
        setShowIoSetUp(true);
        break;
      case "vncSetting":
        setShowVncSetting(true);
        break;
      case "screenshot":
        setOpenScreenshot(true);
        break;
      case "restartSystem":
        setShowRestartSystem(true);
        break;
      // case "kioskMode":
      //   setShowKioskMode(true);
      //   break;
      case "kioskModeAndroid":
        setShowKioskModeAndroid(true);
        break;
      case "kioskModeWindows":
        setShowKioskModeWindows(true);
        break;
      case "rotation":
        setShowRotation(true);
        break;
      case "oraUpdate":
        setShowOraUpdate(true);
        break;
      case "cmsUpdate":
        setShowCmsUpdate(true);
        break;
      case "imageUpdate":
        setShowImageUpdate(true);
        break;
      case "grayscaleUpdate":
        setShowGrayscaleUpdate(true);
        break;
      case "imageGrayscaleUpdate":
        setShowImageGrayscaleUpdate(true);
        break;
      case "disableAndroidDeviceOwner":
        setShowDisableDeviceOwner(true);
        break;
      case "cmsPlayer":
        setShowCMSPlayer(true);
        break;
      case "appRunningStatus":
        try {
          showLoadingIndicator();
          await detectAppRunningApi(selectDevices.map(device => device.id));
          toast.success(t({ defaultMessage: "侦测请求发送成功" }));
        } finally {
          hideLoadingIndicator();
        }
        break;
      default:
        setShowDialog(true);
        break;
    }
  };

  const handleVNCFailedDialogClose = async () => {
    if (selectDevices && selectDevices.length > 0) {
      await localforage.removeItem(`${selectDevices[0]}VNC`);
    }
    setOpenVNC(false);
    setVNCLink();
    setVNCExpiredDate();
  };

  const parseBoolean = value => {
    if (typeof value === "boolean") return value;
    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  };

  const setDeviceTwinsInfo = async () => {
    try {
      const res = await getDeviceTwinsApi(selectDevice.id);
      const properties = res.data.properties.desired.custom_properties ?? {};
      const reported = res.data.properties.reported;
      if (properties.lock_usb_drives !== undefined) {
        setCheckedUsbDrives(parseBoolean(properties.lock_usb_drives));
      }
      if (properties.lock_combination_keys !== undefined) {
        setCheckedFunctionKey(parseBoolean(properties.lock_combination_keys));
      }
      if (properties.disable_windows_notify !== undefined) {
        setCheckedWindowsNotify(
          parseBoolean(properties.disable_windows_notify)
        );
      }
      if (properties.brightness !== undefined) {
        setCheckedBrightness(parseBoolean(properties.brightness.open));
        setSliderBrightness(Math.max(properties.brightness.value, 0));
      }
      if (properties.volume !== undefined) {
        setCheckedVolumes(parseBoolean(properties.volume.open));
        setSliderVolumes(Math.max(properties.volume.value, 0));
      }
      // 已经使用twins
      // if (reported.kiosk_mode !== undefined) {
      //   setKioskMode(reported.kiosk_mode === 1 ? true : false);
      // } else {
      //   setKioskMode(false);
      // }
      // // 已经使用twins
      // if (reported.screen_rotation !== undefined) {
      //   setOrientation(reported.screen_rotation);
      // } else {
      //   setOrientation("");
      // }

      const kiosk_mode = getTwinsDesiredOrReportedByLastUpdated(
        res.data.properties,
        "kiosk_mode"
      );
      const screen_rotation = getTwinsDesiredOrReportedByLastUpdated(
        res.data.properties,
        "screen_rotation"
      );
      const cms_status = getTwinsDesiredOrReportedByLastUpdated(
        res.data.properties,
        "CMS_status"
      );
      setKioskMode(
        typeof kiosk_mode === "number"
          ? kiosk_mode === 1
          : kiosk_mode === "open"
      );
      setOrientation(screen_rotation ?? "");
      setCmsEnabledType(cms_status?.enable_mode ? "1" : "0");
      setCmsPlayEnabledType(cms_status?.enable_player ? "1" : "0");
    } catch (error) {
      console.error(error);
    }
  };

  const onControlClick = (e, type) => {
    if (type === "settingAlarm") {
      onSetAlarm?.(e);
      return false;
    }
    if (type === "settingSchedule") {
      onSetSchedule?.(e);
      return false;
    }
  };

  useEffect(() => {
    localforage.getItem("currentCompanyId").then(setSelectCompany);
  }, []);

  useEffect(() => {
    if (selectDevices.length === 1) {
      setDeviceTwinsInfo();
    }
  }, [showRotation, showKioskMode]);

  return (
    <div className={classes.root}>
      <Grid container spacing={4} className={classes.deviceControlMain}>
        {deviceControlSets
          .filter(e => !e.shouldShow || e.shouldShow())
          .map(e => (
            <HasPermission permission={e.permission} key={e.type}>
              <DeviceControlSet
                type={e.type}
                imgSrc={e.imgSrc}
                notAllowAndroid={e.notAllowAndroid}
                notAllowWindows={e.notAllowWindows}
                notAllowGroup={e.notAllowGroup}
                clickHandler={e.clickHandler}
                {...attributes}
              />
            </HasPermission>
          ))}
        {deviceControlWithSwitch.map(e => (
          <HasPermission permission={e.permission} key={e.type}>
            <DeviceControWithSwitch
              type={e.type}
              imgSrc={e.imgSrc}
              slider={e.slider}
              setSlider={e.setSlider}
              checked={e.checked}
              setChecked={e.setChecked}
              notAllowAndroid={e.notAllowAndroid}
              notAllowWindows={e.notAllowWindows}
              notAllowGroup={e.notAllowGroup}
              setVNCLink={e.setVNCLink}
              setVNCExpiredDate={e.setVNCExpiredDate}
              setDialogContent={e.setDialogContent}
              handleVNCFailedDialogOpen={e.handleVNCFailedDialogOpen}
              onClick={onControlClick}
              {...attributes}
            />
          </HasPermission>
        ))}
      </Grid>
      <VncFailedDialog
        open={openVNC}
        onClose={handleVNCFailedDialogClose}
        dialogContent={dialogContent}
      />
      <ScreenshotDialog
        numType={numType}
        open={openScreenshot}
        selectType={selectType}
        onClose={() => setOpenScreenshot(false)}
        selectDevices={selectDevices}
        selectDevice={selectDevice}
        groupId={groupId}
        tagId={tagId}
        checkAll={checkAll}
        selectCompany={selectCompany}
      />
      <VncSetting
        crossSelect={crossSelect}
        numType={numType}
        open={showVncSetting}
        setOpen={setShowVncSetting}
        selectType={selectType}
        selectDevices={selectDevices}
        selectDevice={selectDevice}
        groupId={groupId}
        tagId={tagId}
        checkAll={checkAll}
        selectCompany={selectCompany}
      />
      <IoSetUp
        numType={numType}
        open={showIoSetUp}
        setOpen={setShowIoSetUp}
        selectType={selectType}
        selectDevices={selectDevices}
        selectDevice={selectDevice}
        groupId={groupId}
        tagId={tagId}
        checkAll={checkAll}
        selectCompany={selectCompany}
      />
      <DeployFile
        numType={numType}
        open={showDeloyFile}
        setOpen={setShowDeloyFile}
        selectType={selectType}
        selectDevices={selectDevices}
        selectDevice={selectDevice}
        groupId={groupId}
        tagId={tagId}
        checkAll={checkAll}
        selectCompany={selectCompany}
      />
      <Rotation
        numType={numType}
        open={showRotation}
        orientation={orientation}
        setOpen={setShowRotation}
        selectType={selectType}
        selectDevices={selectDevices}
        selectDevice={selectDevice}
        groupId={groupId}
        tagId={tagId}
        checkAll={checkAll}
        selectCompany={selectCompany}
      />
      <OraUpdate
        crossSelect={crossSelect}
        numType={numType}
        open={showOraUpdate}
        setOpen={setShowOraUpdate}
        selectType={selectType}
        selectDevices={selectDevices}
        selectDevice={selectDevice}
        groupId={groupId}
        tagId={tagId}
        checkAll={checkAll}
        selectCompany={selectCompany}
      />
      <CmsUpdate
        crossSelect={crossSelect}
        numType={numType}
        open={showCmsUpdate}
        setOpen={setShowCmsUpdate}
        selectType={selectType}
        selectDevices={selectDevices}
        selectDevice={selectDevice}
        groupId={groupId}
        tagId={tagId}
        checkAll={checkAll}
        selectCompany={selectCompany}
      />
      <GrayScaleUpdate
        crossSelect={crossSelect}
        numType={numType}
        open={showGrayscaleUpdate}
        setOpen={setShowGrayscaleUpdate}
        selectType={selectType}
        selectDevices={selectDevices}
        selectDevice={selectDevice}
        groupId={groupId}
        tagId={tagId}
        checkAll={checkAll}
        selectCompany={selectCompany}
      />
      <ImageUpdate
        crossSelect={crossSelect}
        numType={numType}
        open={showImageUpdate}
        setOpen={setShowImageUpdate}
        selectType={selectType}
        selectDevices={selectDevices}
        selectDevice={selectDevice}
        groupId={groupId}
        tagId={tagId}
        checkAll={checkAll}
        selectCompany={selectCompany}
      />
      <ImageGrayScaleUpdate
        crossSelect={crossSelect}
        numType={numType}
        open={showImageGrayscaleUpdate}
        setOpen={setShowImageGrayscaleUpdate}
        selectType={selectType}
        selectDevices={selectDevices}
        selectDevice={selectDevice}
        groupId={groupId}
        tagId={tagId}
        checkAll={checkAll}
        selectCompany={selectCompany}
      />
      <RestartSystem
        numType={numType}
        open={showRestartSystem}
        setOpen={setShowRestartSystem}
        selectType={selectType}
        selectDevices={selectDevices}
        selectDevice={selectDevice}
        groupId={groupId}
        tagId={tagId}
        checkAll={checkAll}
        selectCompany={selectCompany}
      />
      <KioskModeWindows
        numType={numType}
        open={showKioskModeWindows}
        setOpen={setShowKioskModeWindows}
        kioskMode={kioskMode}
        selectType={selectType}
        selectDevices={selectDevices}
        selectDevice={selectDevice}
        groupId={groupId}
        tagId={tagId}
        checkAll={checkAll}
        selectCompany={selectCompany}
        setKioskMode={setKioskMode}
      />
      <KioskModeAndroid
        numType={numType}
        open={showKioskModeAndroid}
        setOpen={setShowKioskModeAndroid}
        kioskMode={kioskMode}
        selectType={selectType}
        selectDevices={selectDevices}
        selectDevice={selectDevice}
        groupId={groupId}
        tagId={tagId}
        checkAll={checkAll}
        selectCompany={selectCompany}
        setKioskMode={setKioskMode}
      />
      <DisableAndroidDeviceOwner
        crossSelect={crossSelect}
        numType={numType}
        open={showDisableDeviceOwner}
        setOpen={setShowDisableDeviceOwner}
        selectType={selectType}
        selectDevices={selectDevices}
        selectDevice={selectDevice}
        groupId={groupId}
        tagId={tagId}
        checkAll={checkAll}
        selectCompany={selectCompany}
      />
      <CMSPlayer
        crossSelect={crossSelect}
        numType={numType}
        cmsEnabledType={cmsEnabledType}
        cmsPlayEnabledType={cmsPlayEnabledType}
        open={showCMSPlayer}
        setOpen={setShowCMSPlayer}
        selectType={selectType}
        selectDevices={selectDevices}
        selectDevice={selectDevice}
        groupId={groupId}
        tagId={tagId}
        checkAll={checkAll}
        selectCompany={selectCompany}
      />
    </div>
  );
};

export default DeviceControls;
